import { useContext } from "react";
import { ContextualHelpContext } from "Components/Organisms/ContextualHelpProvider/ContextualHelpContext";

export default function useContextualHelp() {
    const value = useContext(ContextualHelpContext);

    if (!value) {
        throw new Error("useContextualHelp must be used within a ContextualHelpProvider");
    }

    return value;
}